<app-gmao-spinner *ngIf="!historics"></app-gmao-spinner>
<ng-container *ngIf="historics">
    <table class="table table-hovered">
        <tbody>
            <ng-container *ngFor="let historic of historics.historique_installations">
                <tr>
                    <td><a routerLink="/installation/{{historic.id_installation}}">{{historic.nom_installation}}</a>
                    </td>
                    <td>{{historic.date_installation}} <ng-container *ngIf="historic.date_arret">-
                            {{historic.date_arret}}</ng-container>
                    </td>
                </tr>
            </ng-container>
        </tbody>
    </table>
</ng-container>